module.exports = __webpack_public_path__ + "img/gb13871-92_45x65x8.prt.618cc47b.jpg";